/*
 * Oduree · factuurpagina (/pages/factuur, sjabloon page.factuur, sectie oduree-factuur).
 *
 * De link in de orderbevestiging (en van de knop in de admin) is /factuur/<nummer>/<code>;
 * layout/theme.liquid stuurt die door naar /pages/factuur#o=...&k=... De code is een
 * handtekening die alleen de worker kan controleren (chat-backend/factuur/README.md).
 * Dit script vraagt daarmee het factuurmodel op bij de worker
 * (POST <worker>/factuur/model), laadt daarna pas de PDF-maker en de lettertypen, maakt de
 * PDF in de browser en biedt hem aan.
 *
 * Toestanden (data-staat op de sectie): laden, klaar, geen, ongeldig, storing.
 * Alle teksten staan al in de HTML (vertaalsleutels oduree.factuur.*); dit script kiest
 * alleen welke zichtbaar is. Wat uit het model komt gaat met textContent de pagina in,
 * nooit als HTML.
 *
 * Antwoorden van de worker:
 *   200 { model: {...} }      de factuur (een kaal model mag ook)
 *   elk  { reden: 'code' }    geen factuur voor deze order: onbetaald, geannuleerd,
 *                             abonnement, test, nul, kanaal of overig
 *   400 of 403                de link klopt niet
 *   al het andere             storing, met een knop om het opnieuw te proberen
 */
(function () {
  'use strict';

  var OPSLAG = 'oduree_factuur'; // zelfde sleutel als in snippets/oduree-factuur-sleutel.liquid
  var WACHT_MODEL = 20000; // ms
  var WACHT_MAKER = 45000; // ms: de bundel (met lettertypen) is bijna 2 MB

  function start(wortel) {
    if (wortel.odureeFactuurGestart) return;
    wortel.odureeFactuurGestart = true;

    var kop = wortel.querySelector('[data-factuur-kop]');
    var live = wortel.querySelector('[data-factuur-live]');
    var download = wortel.querySelector('[data-factuur-download]');
    var bekijk = wortel.querySelector('[data-factuur-bekijk]');
    var opnieuw = wortel.querySelector('[data-factuur-opnieuw]');
    var panelen = {};
    Array.prototype.forEach.call(wortel.querySelectorAll('[data-factuur-paneel]'), function (p) {
      panelen[p.getAttribute('data-factuur-paneel')] = p;
    });

    var taal = wortel.getAttribute('data-taal') === 'nl' ? 'nl' : 'en';
    var endpoint = (wortel.getAttribute('data-endpoint') || '').trim().replace(/\/+$/, '');
    var ronde = 0; // elke poging krijgt een nummer: een trage oude poging zet de pagina niet meer om
    var model = null; // bewaard, zodat opnieuw proberen na een mislukte download de worker niet nog eens vraagt
    var modelVoor = '';
    var pdfUrl = '';
    var makerBelofte = null;

    /* ------------------------------------------------------------ toestand tonen */

    function toon(staat, reden) {
      var paneel = panelen[staat];
      if (!paneel) return;
      /* Stond de focus in dit blok (de knop Probeer opnieuw), dan gaat hij mee naar de kop
         van de nieuwe toestand en leest een schermlezer die voor. Anders blijft de focus waar
         hij is en meldt het live-gebied de wijziging. */
      var focusBinnen = wortel.contains(document.activeElement);

      Object.keys(panelen).forEach(function (naam) { panelen[naam].hidden = naam !== staat; });
      wortel.setAttribute('data-staat', staat);
      kop.textContent = paneel.getAttribute('data-kop') || '';

      if (staat === 'geen') {
        var gevonden = false;
        var zinnen = paneel.querySelectorAll('[data-reden]');
        Array.prototype.forEach.call(zinnen, function (zin) {
          var past = zin.getAttribute('data-reden') === reden;
          zin.hidden = !past;
          if (past) gevonden = true;
        });
        if (!gevonden) paneel.querySelector('[data-reden="overig"]').hidden = false;
      }

      var zinnen = [];
      Array.prototype.forEach.call(paneel.querySelectorAll('[data-factuur-zin]'), function (zin) {
        if (!zin.hidden) zinnen.push(zin.textContent.trim());
      });

      if (focusBinnen) {
        live.textContent = '';
        kop.focus();
      } else {
        live.textContent = kop.textContent + '. ' + zinnen.join(' ');
      }
    }

    /* ------------------------------------------------------------ de link */

    function uitOpslag() {
      try { return JSON.parse(sessionStorage.getItem(OPSLAG) || 'null'); } catch (e) { return null; }
    }

    /* Nummer en sleutel uit het adres, of uit wat de <head> er al uit haalde. Staan ze nog in
       het adres (de snippet draaide niet, of de klant plakte een nieuwe link), dan gaan ze hier
       alsnog uit de adresbalk. */
    function leesLink() {
      var bron = null;
      try {
        /* Achter het hekje of in de zoekreeks, en ook met een '&amp;' dat een mailprogramma
           niet terugzette (zelfde regels als snippets/oduree-factuur-sleutel.liquid). */
        var lees = function (deel) {
          var q = new URLSearchParams(String(deel || '').replace(/^[#?]/, '').replace(/&amp;/g, '&'));
          var o = (q.get('o') || q.get('amp;o') || '').match(/^\d+/), k = (q.get('k') || q.get('amp;k') || '').match(/^[0-9a-f]{32}/i);
          return { o: o ? o[0] : '', k: k ? k[0] : '' };
        };
        var h = lees(location.hash), z = lees(location.search);
        if (h.o || h.k || z.o || z.k) {
          bron = { o: h.o || z.o, k: h.k || z.k };
          window.OdureeFactuurLink = bron;
          try { sessionStorage.setItem(OPSLAG, JSON.stringify(bron)); } catch (e) {}
          var rest = new URLSearchParams(location.search);
          ['o', 'k', 'amp;o', 'amp;k'].forEach(function (n) { rest.delete(n); });
          var r = rest.toString();
          history.replaceState(history.state, '', location.pathname + (r ? '?' + r : ''));
        }
      } catch (e) {}
      if (!bron) bron = window.OdureeFactuurLink || uitOpslag();
      if (!bron) return null;
      var o = String(bron.o || '').trim();
      var k = String(bron.k || '').trim().toLowerCase();
      if (!/^\d{1,12}$/.test(o) || !/^[0-9a-f]{32}$/.test(k)) return null;
      return { o: o, k: k };
    }

    /* ------------------------------------------------------------ het model */

    function bruikbaar(m) {
      return !!m && typeof m === 'object' && m.nummer != null && Array.isArray(m.regels) &&
        !!m.totalen && typeof m.totalen.incl === 'number' &&
        !!m.datums && typeof m.datums.factuur === 'string';
    }

    function beoordeel(status, data) {
      if (status === 400 || status === 403) return { soort: 'ongeldig' };
      var m = data && (data.model || (data.soort === 'factuur' ? data : null));
      if (status >= 200 && status < 300 && bruikbaar(m)) return { soort: 'model', model: m };
      var reden = data && typeof data.reden === 'string' ? data.reden : '';
      if (reden || (data && data.beschikbaar === false)) return { soort: 'geen', reden: reden };
      throw new Error('factuur: onverwacht antwoord ' + status);
    }

    function metTijd(belofte, ms, stop) {
      return new Promise(function (ok, fout) {
        var klok = setTimeout(function () {
          if (stop) stop();
          fout(new Error('factuur: te lang gewacht'));
        }, ms);
        belofte.then(
          function (w) { clearTimeout(klok); ok(w); },
          function (e) { clearTimeout(klok); fout(e); }
        );
      });
    }

    function vraagModel(link) {
      var rem = typeof AbortController === 'function' ? new AbortController() : null;
      var verzoek = fetch(endpoint + '/factuur/model', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ o: link.o, k: link.k }),
        signal: rem ? rem.signal : undefined
      }).then(function (r) {
        return r.text().then(function (ruw) {
          var data = null;
          try { data = JSON.parse(ruw); } catch (e) {}
          return beoordeel(r.status, data);
        });
      });
      return metTijd(verzoek, WACHT_MODEL, function () { if (rem) rem.abort(); });
    }

    /* ------------------------------------------------------------ de PDF */

    function laadMaker() {
      if (window.OdureeFactuurPdf) return Promise.resolve(window.OdureeFactuurPdf);
      if (makerBelofte) return makerBelofte;
      makerBelofte = new Promise(function (ok, fout) {
        var s = document.createElement('script');
        s.src = wortel.getAttribute('data-bundel');
        s.async = true;
        s.onload = function () {
          if (window.OdureeFactuurPdf) ok(window.OdureeFactuurPdf);
          else fout(new Error('factuur: PDF-maker ontbreekt'));
        };
        s.onerror = function () {
          if (s.parentNode) s.parentNode.removeChild(s);
          fout(new Error('factuur: PDF-maker niet geladen'));
        };
        document.head.appendChild(s);
      });
      makerBelofte.catch(function () { makerBelofte = null; });
      return makerBelofte;
    }

    /* De lettertypen zitten in de bundel zelf: losse .ttf-bestanden levert het Shopify-CDN als
       WOFF2 af, en daarmee worden de letters in de PDF onleesbaar. */
    function maakPdf(m) {
      return metTijd(laadMaker(), WACHT_MAKER).then(function (maker) {
        return maker.renderFactuurPdf(m, {
          fonts: maker.fonts(),
          logoSvgPaths: maker.leesSvg(maker.logoSvg),
          starSvgPath: maker.leesSvg(maker.sterSvg)
        });
      });
    }

    function zet(selector, tekst) {
      var el = wortel.querySelector(selector);
      if (el) el.textContent = tekst;
    }

    function biedAan(m, bytes) {
      var maker = window.OdureeFactuurPdf;
      var nummer = String(m.nummer);
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
      pdfUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));

      /* Bedrag en datum in de taal van de pagina, met dezelfde notatie als op de factuur. */
      zet('[data-factuur-nummer]', nummer);
      zet('[data-factuur-datum]', maker.formatDatum(m.datums.factuur, taal));
      zet('[data-factuur-totaal]', maker.formatBedrag(m.totalen.incl, taal, m.valuta || 'EUR'));

      var naam = (wortel.getAttribute('data-bestandsnaam') || 'Oduree-factuur') + '-' +
        nummer.replace(/[^0-9A-Za-z-]/g, '') + '.pdf';
      download.setAttribute('href', pdfUrl);
      download.setAttribute('download', naam);
      bekijk.setAttribute('href', pdfUrl);
    }

    /* ------------------------------------------------------------ verloop */

    function haal() {
      var mijn = ++ronde;
      var link = leesLink();
      if (!link) { toon('ongeldig'); return; }
      if (!endpoint) { toon('storing'); return; }
      toon('laden');

      var sleutel = link.o + '|' + link.k;
      var bron = model && modelVoor === sleutel
        ? Promise.resolve({ soort: 'model', model: model })
        : vraagModel(link);

      bron.then(function (antwoord) {
        if (mijn !== ronde) return null;
        if (antwoord.soort === 'ongeldig') { toon('ongeldig'); return null; }
        if (antwoord.soort === 'geen') { toon('geen', antwoord.reden); return null; }
        model = antwoord.model;
        modelVoor = sleutel;
        return maakPdf(model).then(function (bytes) {
          if (mijn !== ronde) return;
          biedAan(model, bytes);
          toon('klaar');
        });
      }).catch(function () {
        if (mijn === ronde) toon('storing');
      });
    }

    if (opnieuw) opnieuw.addEventListener('click', haal);
    window.addEventListener('hashchange', function () {
      if (/(^#|&)(o|k)=/.test(location.hash)) haal();
    });
    haal();
  }

  function begin() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oduree-factuur]'), start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin);
  else begin();
})();
